import { Component, OnInit } from '@angular/core';
import { ApplicationState } from '../../../../store/reducers';
import { Store } from '@ngrx/store';
import {
  ActivateAlarmThresholds,
  CloseModal,
  DeactivateAlarmThresholds,
} from '../../../../store/actions/alarm-threshold.actions';
import { isOptionActive } from '@dch/products-business-logic';

declare let jQuery: any;

@Component({
  selector: 'mprd-alarm-threshold-modal',
  templateUrl: './alarm-threshold-modal.component.html',
})
export class AlarmThresholdModalComponent implements OnInit {
  public acceptTermsAndConditions;
  public option;
  public msisdn;
  public destroy: () => void;

  constructor(private store: Store<ApplicationState>) {}

  ngOnInit(): void {
    const bg = jQuery('.reveal-modal-bg');
    if (bg && bg.on && bg.off) {
      bg.off('click.mynamespace');
      bg.on('click.mynamespace', () => {
        this.close();
      });
    }
  }

  confirm() {
    if (isOptionActive(this.option)) {
      this.store.dispatch(
        new DeactivateAlarmThresholds({ msisdn: this.msisdn }),
      );
      this.destroy();
    } else {
      this.store.dispatch(
        new ActivateAlarmThresholds({
          msisdn: this.msisdn,
          threshold: undefined,
        }),
      );
      this.destroy();
    }
  }

  close() {
    this.store.dispatch(new CloseModal());
    this.destroy();
  }
}
